import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class AuditorService {
  private urlModulo = `${environment.urlAPI}/auditor`;

  constructor(private http: HttpClient) { }

  /**
   * Recupera a lista de auditores do banco
   * @returns Promise com a lista de auditores
   */
  public getListaAuditores(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${this.urlModulo}-lista`)
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data.auditores);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Recupera a lista de GTs para envio de email
   * @param listaGt Lista de GTs
   * @param codigo Código do registro
   * @param filtragem Tipo de filtragem
   * @returns Promise com o resultado da operação
   */
  public getListaGt(listaGt: string, codigo: string, filtragem: string): Promise<any> {
    const params = new HttpParams()
      .set('codigo', codigo)
      .set('filtragem', filtragem)
      .set('listaGt', listaGt);
    
    return new Promise((resolve, reject) => {
      this.http.get(`${this.urlModulo}-listagt`, { params })
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data.retorno);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Recupera a lista de auditores homologados
   * @returns Promise com a lista de auditores homologados
   */
  public getListaAuditoresHomologados(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${this.urlModulo}-listaHomologados`)
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data.auditores);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Recupera a lista de auditores homologados para auditoria
   * @param codSistemaGestao Código do sistema de gestão
   * @returns Promise com a lista de auditores homologados
   */
  public getListaAuditoresHomologadosAuditoria(codSistemaGestao: number): Promise<any> {
    const params = new HttpParams().set('codSistemaGestao', codSistemaGestao.toString());
    
    return new Promise((resolve, reject) => {
      this.http.get(`${this.urlModulo}-listaHomologadosAuditoria`, { params })
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data.auditores);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Recupera a lista de auditores para homologação
   * @returns Promise com a lista de auditores para homologar
   */
  public getListaAuditoresHomologar(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${this.urlModulo}-listahomologar`)
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data.auditores);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Recupera os dados do auditor pelo ID do usuário
   * @param uid ID do usuário auditor
   * @returns Promise com os dados do auditor
   */
  public getAuditorById(uid: number): Promise<any> {
    const params = new HttpParams().set('uid', uid.toString());
    
    return new Promise((resolve, reject) => {
      this.http.get(`${this.urlModulo}-byid`, { params })
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data.auditor);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Recupera os fornecedores com conflito de interesse com o auditor
   * @param codAuditor Código do auditor
   * @returns Promise com a lista de fornecedores em conflito
   */
  public getFornecedoresConflitoByAuditor(codAuditor: number): Promise<any> {
    const params = new HttpParams().set('codAuditor', codAuditor.toString());
    
    return new Promise((resolve, reject) => {
      this.http.get(`${this.urlModulo}-fornecedoresconflito`, { params })
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data.fornecedores);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Recupera os Sistemas de Gestão habilitados para o auditor via workflow
   * @param codAuditor Código do auditor
   * @returns Promise com a lista de sistemas de gestão
   */
  public getSistemaGestaoHabilitadoByAuditor(codAuditor: number): Promise<any> {
    const params = new HttpParams().set('codAuditor', codAuditor.toString());
    
    return new Promise((resolve, reject) => {
      this.http.get(`${this.urlModulo}-sistemagestaohabilitadoworkflow`, { params })
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data.sistemagestao);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Recupera os Sistemas de Gestão para habilitação do auditor
   * @param codAuditor Código do auditor
   * @returns Promise com a lista de sistemas de gestão
   */
  public getSistemaGestaoHabilitacao(codAuditor: number): Promise<any> {
    const params = new HttpParams().set('codAuditor', codAuditor.toString());
    
    return new Promise((resolve, reject) => {
      this.http.get(`${this.urlModulo}-sistemagestaohabilitacao`, { params })
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data.sistemagestao);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Salva auditores homologados
   * @param obj Dados dos auditores homologados
   * @returns Promise com o resultado da operação
   */
  public salvarAuditoresHomologados(obj: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(`${this.urlModulo}-salvarhomologados`, obj)
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Registra workflows de solicitação
   * @param obj Dados dos workflows
   * @returns Promise com o resultado da operação
   */
  public registraWorkflowsSolicitacao(obj: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(`${this.urlModulo}-registrarWorkflowsSolicitacao`, obj)
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Salva a candidatura do auditor
   * @param obj Dados da candidatura
   * @returns Promise com o resultado da operação
   */
  public salvaAuditorCandidatura(obj: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(`${this.urlModulo}-salvarCandidatura`, obj)
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Salva os dados do auditor
   * @param obj Dados do auditor
   * @returns Promise com o resultado da operação
   */
  public salvaAuditor(obj: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(`${this.urlModulo}-salvar`, obj)
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Salva o link da foto do auditor
   * @param obj Dados da foto
   * @returns Promise com o resultado da operação
   */
  public salvaFoto(obj: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(`${this.urlModulo}-salvarfoto`, obj)
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Salva o arquivo de certificado do auditor
   * @param obj Dados do certificado
   * @returns Promise com o resultado da operação
   */
  public salvaArquivoCertificado(obj: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(`${this.urlModulo}-salvarcertificado`, obj)
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Salva os fornecedores com conflito de interesse do auditor
   * @param obj Dados dos conflitos
   * @returns Promise com o resultado da operação
   */
  public salvaConflitoInteresse(obj: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(`${this.urlModulo}-salvarconflitointeresse`, obj)
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Recupera a lista de auditores pela estação atual
   * @param codEstacao Código da estação
   * @returns Promise com a lista de auditores
   */
  public getAuditoresByEstacaoAtual(codEstacao: number): Promise<any> {
    const params = new HttpParams().set('codEstacao', codEstacao.toString());
    
    return new Promise((resolve, reject) => {
      this.http.get(`${this.urlModulo}-byestacaoatual`, { params })
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data.auditores);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Recupera a lista de auditores pela lista de códigos de workflow
   * @param codWorkflows Lista de códigos de workflow
   * @returns Promise com a lista de auditores
   */
  public getAuditorByListaCodWorkflow(codWorkflows: string): Promise<any> {
    const params = new HttpParams().set('codWorkflows', codWorkflows);
    
    return new Promise((resolve, reject) => {
      this.http.get(`${this.urlModulo}-byListaCodWorkflow`, { params })
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data.auditores);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Recupera os dados do workflow do auditor para o cadastro
   * @param codAutor Código do autor
   * @returns Promise com os dados do workflow
   */
  public getAuditorDadosWorkflow(codAutor: number): Promise<any> {
    const params = new HttpParams().set('codAutor', codAutor.toString());
    
    return new Promise((resolve, reject) => {
      this.http.get(`${this.urlModulo}-dadosWorkflow`, { params })
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data.dados);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Recupera informações do workflow de aprovação do Sistema de Gestão
   * @param codWorkflow Código do workflow
   * @returns Promise com os dados do workflow
   */
  public getAuditorDadosWorkflowSistemaGestao(codWorkflow: number): Promise<any> {
    const params = new HttpParams().set('codWorkflow', codWorkflow.toString());
    
    return new Promise((resolve, reject) => {
      this.http.get(`${this.urlModulo}-dadosWorkflowSistemaGestao`, { params })
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data.dados);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Recupera informações de homologação para o auditor
   * @param codAutor Código do autor
   * @param codSistemaGestao Código do sistema de gestão
   * @returns Promise com os dados de homologação
   */
  public getHomologacao(codAutor: number, codSistemaGestao: number): Promise<any> {
    const params = new HttpParams()
      .set('codSistemaGestao', codSistemaGestao.toString())
      .set('codAutor', codAutor.toString());
    
    return new Promise((resolve, reject) => {
      this.http.get(`${this.urlModulo}-dadosHomologacao`, { params })
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data.dados);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Altera o status do auditor
   * @param codigo Código do auditor
   * @param status Novo status
   * @returns Promise com o resultado da operação
   */
  public alterarStatusAuditor(codigo: number, status: number): Promise<any> {
    const payload = {
      codigo: codigo,
      status: status
    };
    
    return new Promise((resolve, reject) => {
      this.http.post(`${this.urlModulo}-alterarstatus`, payload)
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Altera o status do auditor pelo código do usuário
   * @param codUsuario Código do usuário
   * @param status Novo status
   * @returns Promise com o resultado da operação
   */
  public alterarStatusAuditorByCodUsuario(payload): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(`${this.urlModulo}-alterarstatus-byuid`, payload)
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Gera workflow de sistema de gestão para o auditor
   * @param obj Dados do workflow
   * @returns Promise com o resultado da operação
   */
  public gerarWorkflowSistemaGestaoAuditor(obj: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(`${this.urlModulo}-workflowsistemagestaoauditor`, obj)
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Grava aprovação GT qualificação
   * @param obj Dados da aprovação
   * @returns Promise com o resultado da operação
   */
  public gravaAprovacaoGTQualificacao(obj: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(`${this.urlModulo}-gravaaprovacaogtqualificacao`, obj)
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Retira habilitação do auditor para sistema de gestão
   * @param obj Dados da habilitação
   * @returns Promise com o resultado da operação
   */
  public retiraHabilitacaoAuditorSistemaGestao(obj: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(`${this.urlModulo}-retirahabilitacaoauditorsistemagestao`, obj)
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  /**
   * Recupera a equipe de auditores por workflow
   * @param codWorkflow Código do workflow
   * @returns Promise com os dados da equipe
   */
  public getEquipeAuditoresByWorkflow(codWorkflow: number): Promise<any> {
    const params = new HttpParams().set('codWorkflow', codWorkflow.toString());
    
    return new Promise((resolve, reject) => {
      this.http.get(`${this.urlModulo}-recuperarEquipeAuditoriaByWorkflow`, { params })
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data.dados);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }
}


// WEBPACK FOOTER //
// /app/src/app/services/auditor.service.ts